module.exports = __webpack_public_path__ + "img/DoraImg.0849873c.jpg";